module.exports = __webpack_public_path__ + "static/media/GuardianEgyp-Light.095ee8ed.otf";